import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import { TextArea } from '../../components/Inputs/TextArea'
import Button from '../../components/General/Button'
import Select from '../../components/Inputs/Select'

export const FoodOrderForm: React.FC<FoodOrderFormProps> = ({
  onSubmit,
  onClose,
  useType,
  isLoading,
  defaultValues,
  tables,
  isFromFoodTable = false,
}) => {
  const form = useForm<IFormFoodOrder>({
    defaultValues: {
      idFoodTable: defaultValues?.idFoodTable || '',
      type: defaultValues?.type || 'delivery',
      observations: defaultValues?.observations || '',
    },
  })

  const typeOptions = [
    { value: 'delivery', text: 'Delivery' },
    { value: 'pickup', text: 'Pickup' },
    { value: 'dine_in', text: 'En sitio' },
  ]

  const onGetDefaultTable = () => {
    if (isFromFoodTable || defaultValues?.foodTable) {
      return tables.find((table) => table.value === (isFromFoodTable ? defaultValues.idFoodTable : defaultValues.foodTable?.id))
    }
    return null
  }

  const onGetDefaultType = () => {
    if (defaultValues?.type) {
      return typeOptions.find((type) => type.value === defaultValues.type)
    }
    return null
  }

  return (
    <Form classes="grid grid-cols-12 gap-3" form={form} onSubmit={onSubmit}>
      <div className="col-span-12">
        <h1 className="text-2xl font-bold">
          {useType === 'watch' ? 'Ver comanda' : useType === 'edit' ? 'Editar comanda' : 'Crear comanda'}
        </h1>
      </div>

      <FormItem
        name="idFoodTable"
        rules={{ required: 'Es necesario una mesa' }}
        classes="col-span-12"
        defaultValue={onGetDefaultTable()}
      >
        <Select  disabled={isFromFoodTable || useType === 'watch' || useType === 'edit'} options={tables} label="Mesa" disableInput={useType === 'watch'} />
      </FormItem>


      <FormItem
        name="type"
        rules={{ required: 'Es necesario un tipo de comanda' }}
        classes="col-span-12"
        defaultValue={onGetDefaultType()}
      >
        <Select options={typeOptions} label="Tipo de comanda" disableInput={useType === 'watch'} />
      </FormItem>


      <FormItem
        name="observations"
        classes="col-span-12"
      >
        <TextArea label="Observaciones" disableInput={useType === 'watch'} />
      </FormItem>

      {useType !== 'watch' && (
        <div className="flex col-span-12 gap-3">
          <Button
            type="outline"
            classes="w-1/2"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button
            type="primary"
            classes="w-1/2"
            htmlType="submit"
            loading={isLoading}
            disabled={isLoading}
          >
            {useType === 'create' ? 'Añadir' : 'Guardar cambios'}
          </Button>
        </div>
      )}
    </Form>
  )
}

interface FoodOrderFormProps {
  onSubmit: (data: IFormFoodOrder) => void
  onClose: () => void
  useType?: 'create' | 'edit' | 'watch'
  isLoading?: boolean
  defaultValues?: any
  tables: {value: string, text: string}[]
  isFromFoodTable?: boolean
}

export interface IFormFoodOrder {
  idFoodTable: string
  type: string
  observations: string | null
}